import React from "react";
import SwitchInput from "../../../../core/form/SwitchInput";

let BusinessEnabledField = (props) => {

    return <SwitchInput
        name='enabled'
        label='Aktywny'
        {...props}
    />

}

export default BusinessEnabledField